module.exports = __webpack_public_path__ + "static/banner-home-f97f807b8410d446c23c255443ed3f0c.jpg";